import { createContext, useContext, useState } from "react";

const ModalContext = createContext()

export const useModal = () => useContext(ModalContext)

export const ModalProvider = ({ children }) => {
    const [showModal, setShowModal] = useState(false)
    console.log(showModal)
    return (
        <ModalContext.Provider value={{ showModal, setShowModal }}>
            {children}
        </ModalContext.Provider>
    )
}